import React from 'react';
import styles from './FeedbackBox.module.css';

export type FeedbackBoxStatusType = 'success' | 'error' | 'info' | 'warning' | 'loading';

export interface FeedbackBoxAction {
  label: string;
  onClick: () => void;
  isLoading?: boolean;
  variant?: 'primary' | 'secondary' | 'danger' | 'default';
  icon?: React.ReactNode;
  disabled?: boolean;
}

export interface FeedbackBoxProps {
  statusType: FeedbackBoxStatusType;
  title?: string;
  message?: React.ReactNode;
  details?: React.ReactNode;
  actions?: FeedbackBoxAction[];
  icon?: React.ReactNode;
  className?: string;
}

const DefaultIcons: Record<FeedbackBoxStatusType, React.ReactNode> = {
  success: <span>✔️</span>, // Placeholder, replace with actual icon
  error: <span>❌</span>,   // Placeholder, replace with actual icon
  info: <span>ℹ️</span>,    // Placeholder, replace with actual icon
  warning: <span>⚠️</span>, // Placeholder, replace with actual icon
  loading: null, // No default icon for loading, spinner will be shown
};

export const FeedbackBox: React.FC<FeedbackBoxProps> = ({
  statusType,
  title,
  message,
  details,
  actions,
  icon,
  className,
}) => {
  const statusClass = styles[statusType] || '';
  const customIcon = icon !== undefined ? icon : DefaultIcons[statusType];

  return (
    <div className={`${styles.feedbackBoxContainer} ${statusClass} ${className || ''}`}>
      {statusType === 'loading' ? (
        <div className={styles.loadingSpinner}>Caricamento...</div> // Placeholder for spinner
      ) : (
        customIcon && <div className={styles.iconArea}>{customIcon}</div>
      )}
      <div className={styles.contentArea}>
        {title && <h3 className={styles.title}>{title}</h3>}
        {message && <div className={styles.message}>{message}</div>}
        {details && <div className={styles.details}>{details}</div>}
      </div>
      {actions && actions.length > 0 && (
        <div className={styles.actionsArea}>
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              disabled={action.disabled || action.isLoading}
              className={`${styles.actionButton} ${action.variant ? styles[action.variant] : styles.default}`}
            >
              {action.isLoading ? 'Caricamento...' : action.icon}
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};